import React, { useState, useEffect } from "react";
import { Grid, Button, Header } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
const VehileList = () => {
  const navigate = useNavigate();
  const userDetail = userData();
  const [excelData, setexcelData] = useState([]);
  const [rowData, setrowData] = useState([]);
  useEffect(() => {
    getVechileList();
  }, []);

  const getVechileList = () => {
    axios
      .post(BaseUrlInvoice + "accounts/listVehicle", { vehicleId: 1 })
      .then((res) => {
        console.log(res.data);
        setrowData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columnDefs = [
    { headerName: "Vehicle Type", field: "vehicleType" },
    { headerName: "Brand", field: "vehicleBrand" }, //customerName
    { headerName: "Model", field: "model" },
    { headerName: "Fuel", field: "fuelType" },
    { headerName: "Cur OdoMeter", field: "currentOdoMeter" },
    // { headerName: "Application Num", field: "applicationNumber" },

    { headerName: "Driven By", field: "lastDrivenBy" },
    // { headerName: "ID", field: "id" },
    { headerName: "Last Service ", field: "lastServiceDoneOn" },
    { headerName: "Last Service Kms", field: "lastServiceKms" },

    // { headerName: "Status", field: "status" },
    // { headerName: "Customer Name", field: "customerName" },

    {
      headerName: "Edit/Delete",
      filter: false,
      field: "ssVisaId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => updateRecord(params)}>
            <AiFillEdit />
          </Button>
          <Button color="red" onClick={() => deleteRecord(params)}>
            <AiFillDelete />
          </Button>
        </div>
      ),
    },
  ];

  const updateRecord = (params) => {
    navigate(`/create-new-vehicle/${params.data.vehicleId}`);
  };
  const deleteRecord = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrlInvoice + "accounts/deleteVehicle", {
            vehicleId: params.data.vehicleId,
          })
          .then((res) => {
            console.log("res", res.data);
            Swal.fire(
              "Deleted!",
              "Vehicle Recored has been deleted.",
              "success"
            );
            getVechileList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };
  const defaultColDef = {
    sortable: true,
    editable: true,
    // flex: 1,
    filter: true,
    floatingFilter: true,
  };

  return (
    <div>
      <Header dividing size="huge" as="h1">
        Vehicle List
      </Header>
      <Grid.Row>
        <Button
          color="primary"
          onClick={() => navigate(`/create-new-vehicle/null`)}
        >
          Create New
        </Button>
      </Grid.Row>
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default VehileList;
